export default "__VITE_ASSET__C_0$h2Ad__"